import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer';
import MapView from '@arcgis/core/views/MapView';
import { Tool, ToolSlot } from 'cd-eft/components/Design/BreaklineTools/framework/Tool';
import { SurfaceDef } from 'cd-eft/components/Design/BreaklineTools/model/SurfaceDef';
import { InsertBorderPointsInputTask } from './InsertBorderPointsInputTask';

export class InsertBorderPointsTool extends Tool {
  private readonly mapView: MapView;
  private readonly surfaceDef: SurfaceDef;
  private task: InsertBorderPointsInputTask;
  private borderLayer: GraphicsLayer;

  constructor(mapView: MapView, surfaceDef: SurfaceDef, toolSlot: ToolSlot, borderLayer: GraphicsLayer) {
    super('Insert Border Points', 'single', toolSlot);
    this.mapView = mapView;
    this.surfaceDef = surfaceDef;
    this.task = new InsertBorderPointsInputTask(this.mapView, this.surfaceDef);
    this.borderLayer = borderLayer;
  }

  protected async onExecuteOperation(): Promise<void> {
    const result = await this.task.executeTaskAsync();

    this.surfaceDef.border = result;
    if (this.surfaceDef.isCurrentIdentiticalToOriginalBorder()) {
      this.surfaceDef.clearBorderSyncStatus();
    }

    //redraw layer
    this.borderLayer.removeAll();
    const graphic = result.generatePolygonGraphic(this.mapView.spatialReference);
    this.borderLayer.add(graphic);

    return;
  }

  protected async onCancelOperation(): Promise<void> {
    if (this.task.isExecuting) {
      await this.task.cancelTaskAsync();
    }
    return;
  }

  public reDrawBorder() {
    this.borderLayer.removeAll();
    const graphic = this.surfaceDef.border.generatePolygonGraphic(this.mapView.spatialReference);
    this.borderLayer.add(graphic);
  }
}
